import React from "react";
import { get } from "lodash";
import { getInvitation, acceptInvitation } from "../api";
import { Box } from "grid-styled";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { logIn } from "../ducks/auth";
import Button, { LinkButton } from "./Button";
import Label from "./forms/Label";
import Input from "./forms/Input";
import ErrorMessage from "./forms/ErrorMessage";
import LoginWrapper from "./LoginWrapper";
import { H2 } from "./Heading";
import CenteredLoader from "./CenteredLoader";
import Alert from "./Alert";

class AcceptInvitation extends React.Component {
  state = {
    invitation: null,
    loading: false,
    error: null,
    submitting: false,
    submissionErrors: null,
    redirectToApp: false,
    formErrors: {},
    values: {
      name: "",
      password: "",
      passwordConfirmation: ""
    },
    touched: {
      name: false,
      password: false,
      passwordConfirmation: false
    }
  };

  getToken() {
    return get(this.props, "match.params.token", "");
  }

  componentDidMount() {
    const token = this.getToken();

    this.setState({ loading: true });
    getInvitation(token)
      .then(invitation => {
        this.setState({ invitation, loading: false });
      })
      .catch(err => {
        this.setState({
          invitation: null,
          error: "This invitation does not exist or was already redeemed.",
          loading: false
        });
      });
  }

  validate = () => {
    const { values } = this.state;
    const errors = {};
    if (!values.name.trim()) {
      errors.name = "Name must be filled out.";
    }
    if (!values.password.trim()) {
      errors.password = "Password must be filled out.";
    }
    if (values.password !== values.passwordConfirmation) {
      errors.passwordConfirmation = "Passwords must match.";
    }
    this.setState({ formErrors: errors });
  };

  resetTouched = () => {
    this.setState(state => {
      const touched = {};
      Object.keys(state.touched).forEach(key => {
        touched[key] = false;
      });
      return { touched };
    });
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState(state => ({
      values: {
        ...state.values,
        [name]: value
      }
    }));
  };

  handleBlur = e => {
    const { name } = e.target;
    this.setState(state => ({
      touched: {
        ...state.touched,
        [name]: true
      }
    }));
  };

  handleSubmit = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const token = this.getToken();
    const { values, invitation } = this.state;
    this.setState({ submitting: true });
    return acceptInvitation(token, { user: values })
      .then(() => {
        this.props
          .logIn(invitation.user.email, values.password)
          .then(() => {
            this.setState({ redirectToApp: true });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
      })
      .catch(errors => {
        this.setState({
          submitting: false,
          submissionErrors: {
            msg: "There were errors trying to accep this invitation."
          }
        });
      });
  };

  isValid() {
    return !Object.keys(this.state.formErrors).length;
  }

  hasError(field) {
    return !!(this.state.formErrors[field] && this.state.touched[field]);
  }

  render() {
    const {
      loading,
      error,
      values,
      formErrors,
      submitting,
      redirectToApp,
      touched,
      submissionErrors
    } = this.state;

    if (loading) return <CenteredLoader />;
    if (error)
      return (
        <LoginWrapper>
          <Alert>{error}</Alert>
          <LinkButton to="/login">Back to Login</LinkButton>
        </LoginWrapper>
      );

    const nameError = this.hasError("name");
    const passwordError = this.hasError("password");
    const confirmationError = this.hasError("passwordConfirmation");

    if (redirectToApp) return <Redirect to="/" />;

    return (
      <LoginWrapper>
        <form onSubmit={this.handleSubmit}>
          <H2>Accept Invitation</H2>
          <Box py={2}>
            <Label hasError={nameError}>Name</Label>
            <Input
              type="text"
              name="name"
              value={values.name}
              onChange={this.handleChange}
              hasError={nameError}
            />
            {nameError && <ErrorMessage>{formErrors.name}</ErrorMessage>}
          </Box>
          <Box pb={2}>
            <Label hasError={passwordError}>Password</Label>
            <Input
              type="password"
              name="password"
              value={values.password}
              onChange={this.handleChange}
              hasError={passwordError}
            />
            {passwordError && (
              <ErrorMessage>{formErrors.password}</ErrorMessage>
            )}
          </Box>
          <Box pb={2}>
            <Label hasError={confirmationError}>Confirm Password</Label>
            <Input
              type="password"
              name="passwordConfirmation"
              value={values.passwordConfirmation}
              onChange={this.handleChange}
              hasError={confirmationError}
            />
            {confirmationError && (
              <ErrorMessage>{formErrors.passwordConfirmation}</ErrorMessage>
            )}
          </Box>
          <Box>
            <Button primary disabled={!this.isValid()} type="submit">
              {submitting ? "Submitting..." : "Accept Invitation"}
            </Button>
          </Box>
        </form>
      </LoginWrapper>
    );
  }
}

export default connect(null, { logIn })(AcceptInvitation);



// WEBPACK FOOTER //
// ./src/components/AcceptInvitation.js